class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) {
      return;
    }
    this.summary = this.mainDetailsToggle.querySelector('summary');
    if (!this.summary) {
      return;
    }
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Desktop dropdown menu (snippets/header-dropdown-menu.liquid). Submenus also open on hover via CSS;
// this adds the keyboard and screen-reader path: Enter/Space toggles, Escape closes, leaving the menu closes it.
class DropdownDisclosure extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button[aria-expanded]');
    if (!this.button) return;
    this.item = this.closest('li') || this;

    this.button.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
    this.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape' || !this.isOpen()) return;
      this.close();
      this.button.focus();
    });
    this.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    });
    document.addEventListener('click', (event) => {
      if (this.isOpen() && !this.contains(event.target)) this.close();
    });
  }

  isOpen() {
    return this.button.getAttribute('aria-expanded') === 'true';
  }

  open() {
    document.querySelectorAll('dropdown-disclosure').forEach((disclosure) => {
      if (disclosure !== this) disclosure.close();
    });
    this.button.setAttribute('aria-expanded', 'true');
    this.item.classList.add('is-open');
  }

  close() {
    if (!this.button) return;
    this.button.setAttribute('aria-expanded', 'false');
    this.item.classList.remove('is-open');
  }
}

customElements.define('dropdown-disclosure', DropdownDisclosure);